export const GSV_ID = {
  h24: {
    DE: 'ieWRTAgmwGe57qzWjvMuyhvSaUnyh8wO3B_cW9VIA_o',
    FR: 'IdUDdIijUasPwxOR1PO1ww_nGqPfKBgjOvRnMI2vGPo',
    NL: 'mjVqpiBwOumMNdlKgbpZzQkqkbXFcgBnRvp9EGY9lwU',
    AT: 'FzCeEoK6LXbCHJqz6PGiNuTEc0eKLGTV962FOm9T5JI',
    CH: '-RMuX9ZfeBW-UvVvNrqahSbiGgehy7GvmfsnrE3J20g',
    BE: 'qy5VMGk-dN8mS-2zHtCBnTX3QOI2gMdYRKGPLGRB0XQ',
    IT: 'fMj9sP0ElBoxKMtegnvjZyLR2q7C2KASdK45agg1YA0',
  },
};
